import React from "react";

const Twitter = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9672 9.59081L19.4521 0.889404H17.6776L11.1779 8.4447L5.98693 0.889404H0L7.8502 12.3137L0 21.439H1.77446L8.63773 13.4598L14.1203 21.439H20.1072L11.9655 9.59081H11.9672ZM9.53753 12.4142L8.74162 11.2765L2.41287 2.22486H5.1374L10.2446 9.53049L11.0405 10.6682L17.6793 20.1639H14.9548L9.53753 12.4159V12.4142Z"
      fill={color}
    />
  </svg>
);

Twitter.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Twitter;
